export class LegRequestInput {
  departureTimeUTC: Date;
  departureAirportCode: string;
  arrivalAirportCode: string;
  departureFboId: number;
  arrivalFboId: number;
  newDepartureTime: Date;
  newArrivalAirportCode: string;
  newDepartureAirportCode: string;
  toIsTechStop?: boolean;
  pax: number;
}
